// extracted by mini-css-extract-plugin
module.exports = {"content":"Stages_content__2OqBM","wrapper":"Stages_wrapper__3F27G","wrapperLife":"Stages_wrapperLife__l7mUs"};